import React from "react";
import { motion } from "framer-motion";
const MobileDevFlow = () => {
  return (
    <div className="serivces_flow serivces_flow6" id="wrap">
      <div className="titles">
        <div className="wrapper">
          {/* <a href="javascript:void(0)" className="btn-blue">
            HEIGHTEN YOUR SPLENDOUR
          </a>
          <h3>Technology We Use</h3>
          <p>
            Reference site about Lorem Ipsum, giving informationon its origins,
            as well as a random Lipsum generator. Reference site about Lorem
            Ipsum, giving informationon its origins, as well as a random Lipsum
            generator.
          </p> */}
        </div>
      </div>
      <div className="wrapper">
        <div className="service_flow_wrap">
          <svg
            width="830"
            height="1318"
            viewBox="0 0 830 1318"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_i_100_228)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M111.717 207.501C109.048 207.708 106.351 207.812 103.629 207.812C46.4674 207.812 0.128906 161.474 0.128906 104.312C0.128906 47.151 46.4674 0.8125 103.629 0.8125C124.168 0.8125 143.31 6.79531 159.407 17.1133C173.432 26.1034 188.868 33.8125 205.527 33.8125H554.129C602.178 33.8125 641.129 72.7637 641.129 120.812C641.129 168.861 602.178 207.812 554.129 207.812H119.129C116.632 207.812 114.16 207.707 111.717 207.501Z"
                fill="white"
              />
            </g>
            <path
              d="M111.759 207.003L111.718 207L111.678 207.003C109.022 207.208 106.338 207.312 103.629 207.312C46.7436 207.312 0.628906 161.198 0.628906 104.312C0.628906 47.4271 46.7436 1.3125 103.629 1.3125C124.07 1.3125 143.118 7.26633 159.137 17.5342C173.181 26.5359 188.718 34.3125 205.527 34.3125H554.129C601.902 34.3125 640.629 73.0398 640.629 120.812C640.629 168.585 601.902 207.312 554.129 207.312H119.129C116.646 207.312 114.188 207.208 111.759 207.003Z"
              stroke="#00E1DB"
            />
            <circle
              cx="103.629"
              cy="104.312"
              r="82.5"
              fill="url(#paint0_linear_100_228)"
            />
            <circle
              opacity="0.9"
              cx="103.629"
              cy="104.312"
              r="59.1949"
              fill="white"
            />
            <g clip-path="url(#clip0_100_228)">
              <path
                d="M120.255 80.775C120.255 78.3141 118.253 76.3125 115.792 76.3125H91.4674C89.0064 76.3125 87.0049 78.3141 87.0049 80.775V82.432H120.255V80.775Z"
                fill="#1375B2"
              />
              <path
                d="M87.0049 85.7129H120.255V88.9996H87.0049V85.7129Z"
                fill="#1375B2"
              />
              <path
                d="M87.0049 127.85C87.0049 130.311 89.0064 132.312 91.4674 132.312H115.792C118.253 132.312 120.255 130.311 120.255 127.85V121.812H87.0049V127.85ZM100.841 124.656H106.419C107.325 124.656 108.06 125.391 108.06 126.297C108.06 127.202 107.325 127.938 106.419 127.938H100.841C99.9352 127.938 99.2002 127.202 99.2002 126.297C99.2002 125.391 99.9352 124.656 100.841 124.656Z"
                fill="#1375B2"
              />
              <path
                d="M122.771 92.2812H84.4893C83.5836 92.2812 82.8486 93.0163 82.8486 93.9219V116.891C82.8486 117.796 83.5836 118.531 84.4893 118.531H122.771C123.676 118.531 124.411 117.796 124.411 116.891V93.9219C124.411 93.0163 123.676 92.2812 122.771 92.2812ZM97.681 107.692C98.3219 108.332 98.3219 109.371 97.681 110.012C97.3605 110.332 96.9405 110.492 96.5205 110.492C96.1005 110.492 95.6805 110.332 95.36 110.012L91.9147 106.567C91.2749 105.926 91.2749 104.887 91.9147 104.247L95.36 100.802C96.001 100.161 97.04 100.161 97.681 100.802C98.3219 101.441 98.3219 102.48 97.681 103.121L95.395 105.406L97.681 107.692ZM106.755 99.7997L103.685 111.824C103.474 112.694 102.543 113.239 101.688 113.008C100.811 112.784 100.281 111.89 100.505 111.013L103.575 98.9881C103.791 98.1242 104.691 97.5748 105.571 97.8047C106.448 98.0289 106.979 98.9225 106.755 99.7997ZM115.345 106.567L111.9 110.012C111.579 110.332 111.159 110.492 110.739 110.492C110.319 110.492 109.899 110.332 109.579 110.012C108.939 109.371 108.939 108.332 109.579 107.691L111.865 105.406L109.579 103.121C108.939 102.48 108.939 101.441 109.579 100.8C110.22 100.161 111.259 100.161 111.9 100.8L115.345 104.246C115.985 104.887 115.985 105.926 115.345 106.567Z"
                fill="#1375B2"
              />
            </g>
            <g filter="url(#filter1_i_100_228)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M111.717 644.501C109.048 644.708 106.351 644.812 103.629 644.812C46.4674 644.812 0.128906 598.474 0.128906 541.312C0.128906 484.151 46.4674 437.812 103.629 437.812C124.168 437.812 143.31 443.795 159.407 454.113C173.432 463.103 188.868 470.812 205.527 470.812H554.129C602.178 470.812 641.129 509.764 641.129 557.812C641.129 605.861 602.178 644.812 554.129 644.812H119.129C116.632 644.812 114.16 644.707 111.717 644.501Z"
                fill="white"
              />
            </g>
            <path
              d="M111.759 644.003L111.718 644L111.678 644.003C109.022 644.208 106.338 644.312 103.629 644.312C46.7436 644.312 0.628906 598.198 0.628906 541.312C0.628906 484.427 46.7436 438.312 103.629 438.312C124.07 438.312 143.118 444.266 159.137 454.534C173.181 463.536 188.718 471.312 205.527 471.312H554.129C601.902 471.312 640.629 510.04 640.629 557.812C640.629 605.585 601.902 644.312 554.129 644.312H119.129C116.646 644.312 114.188 644.208 111.759 644.003Z"
              stroke="#00E1DB"
            />
            <circle
              cx="103.629"
              cy="541.312"
              r="82.5"
              fill="url(#paint1_linear_100_228)"
            />
            <circle
              opacity="0.9"
              cx="103.629"
              cy="541.312"
              r="59.1949"
              fill="white"
            />
            <g clip-path="url(#clip1_100_228)">
              <path
                d="M110.739 518.772V519.875H75.6299V518.772C75.6299 515.761 78.0788 513.312 81.0899 513.312H105.279C108.29 513.312 110.739 515.761 110.739 518.772Z"
                fill="#0051C4"
              />
              <path
                d="M85.583 554.109H100.677V559.469H85.583V554.109Z"
                fill="#0051C4"
              />
              <path
                d="M75.6299 523.156V559.469H82.3018V552.469C82.3018 551.563 83.0368 550.828 83.9424 550.828H102.317C103.223 550.828 103.958 551.563 103.958 552.469V559.469H110.739V523.156H75.6299ZM102.317 547.547H83.9424C83.0368 547.547 82.3018 546.812 82.3018 545.906C82.3018 545.001 83.0368 544.266 83.9424 544.266H102.317C103.223 544.266 103.958 545.001 103.958 545.906C103.958 546.812 103.223 547.547 102.317 547.547ZM103.958 539.344C103.958 540.249 103.223 540.984 102.317 540.984H83.9424C83.0368 540.984 82.3018 540.249 82.3018 539.344V528.078C82.3018 527.173 83.0368 526.438 83.9424 526.438H102.317C103.223 526.438 103.958 527.173 103.958 528.078V539.344ZM85.583 537.703H100.677V529.719H85.583V537.703Z"
                fill="#0051C4"
              />
              <path
                d="M75.6299 562.75H110.739V563.852C110.739 566.864 108.29 569.312 105.279 569.312H81.0899C78.0788 569.312 75.6299 566.864 75.6299 563.852V562.75Z"
                fill="#0051C4"
              />
              <path
                d="M116.308 524.25H122.329V556.188H116.308V524.25Z"
                fill="#0051C4"
              />
              <path
                d="M116.99 559.469H130.949L125.282 568.594C125.005 569.04 124.508 569.312 123.969 569.312C123.431 569.312 122.933 569.04 122.655 568.594L116.99 559.469Z"
                fill="#0051C4"
              />
              <path
                d="M131.63 517.328V520.969H116.308V517.328C116.308 515.11 118.106 513.312 120.324 513.312H127.614C129.833 513.312 131.63 515.11 131.63 517.328Z"
                fill="#0051C4"
              />
              <path
                d="M125.611 524.25H131.631V556.188H125.611V524.25Z"
                fill="#0051C4"
              />
            </g>
            <g filter="url(#filter2_i_100_228)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M111.717 1078.5C109.048 1078.71 106.351 1078.81 103.629 1078.81C46.4674 1078.81 0.128906 1032.47 0.128906 975.312C0.128906 918.151 46.4674 871.812 103.629 871.812C124.168 871.812 143.31 877.795 159.407 888.113C173.432 897.103 188.868 904.812 205.527 904.812H554.129C602.178 904.812 641.129 943.764 641.129 991.812C641.129 1039.86 602.178 1078.81 554.129 1078.81H119.129C116.632 1078.81 114.16 1078.71 111.717 1078.5Z"
                fill="white"
              />
            </g>
            <path
              d="M111.759 1078L111.718 1078L111.678 1078C109.022 1078.21 106.338 1078.31 103.629 1078.31C46.7436 1078.31 0.628906 1032.2 0.628906 975.312C0.628906 918.427 46.7436 872.312 103.629 872.312C124.07 872.312 143.118 878.266 159.137 888.534C173.181 897.536 188.718 905.312 205.527 905.312H554.129C601.902 905.312 640.629 944.04 640.629 991.812C640.629 1039.59 601.902 1078.31 554.129 1078.31H119.129C116.646 1078.31 114.188 1078.21 111.759 1078Z"
              stroke="url(#paint2_linear_100_228)"
            />
            <circle
              cx="103.629"
              cy="975.312"
              r="82.5"
              fill="url(#paint3_linear_100_228)"
            />
            <circle
              opacity="0.9"
              cx="103.629"
              cy="975.312"
              r="59.1949"
              fill="white"
            />
            <g clip-path="url(#clip2_100_228)">
              <path
                d="M94.3877 952.672H101.388C102.413 952.672 103.247 951.838 103.247 950.812V947.312H92.5283V950.812C92.5283 951.838 93.3624 952.672 94.3877 952.672Z"
                fill="#1BB738"
              />
              <path
                d="M117.451 975.313C117.451 974.175 116.525 973.249 115.387 973.249C114.249 973.249 113.323 974.175 113.323 975.313C113.323 976.451 114.249 977.377 115.387 977.377C116.525 977.377 117.451 976.451 117.451 975.313Z"
                fill="#1BB738"
              />
              <path
                d="M117.508 987.35V986.641C117.508 985.068 118.354 983.602 119.716 982.815C121.079 982.027 122.774 982.027 124.137 982.814L124.751 983.169L126.873 979.494L126.262 979.141C124.898 978.354 124.051 976.887 124.051 975.312C124.051 973.738 124.898 972.271 126.261 971.484L126.873 971.131L124.751 967.456L124.137 967.811C122.778 968.595 121.092 968.597 119.731 967.818C118.415 967.086 117.502 965.509 117.508 963.976V963.274H113.265V963.969C113.288 965.473 112.38 967.052 111.052 967.813C109.694 968.598 108 968.598 106.636 967.811L106.022 967.456L103.901 971.131L104.512 971.484C105.875 972.271 106.722 973.738 106.722 975.313C106.722 976.887 105.875 978.354 104.512 979.141L103.9 979.494L106.022 983.169L106.636 982.814C108 982.027 109.694 982.027 111.057 982.816C112.419 983.603 113.265 985.069 113.265 986.642V987.35H117.508V987.35ZM110.042 975.312C110.042 972.365 112.439 969.967 115.387 969.967C118.334 969.967 120.732 972.365 120.732 975.312C120.732 978.259 118.334 980.657 115.387 980.657C112.44 980.657 110.042 978.259 110.042 975.312Z"
                fill="#1BB738"
              />
              <path
                d="M109.985 990.632V986.642C109.985 986.237 109.767 985.859 109.416 985.656C109.065 985.454 108.629 985.453 108.278 985.656L106.118 986.903V990.133H89.6572V986.852H104.361L102.45 983.543H92.9521V980.262H100.556L99.4193 978.293L102.872 976.3C103.224 976.097 103.442 975.719 103.442 975.313C103.442 974.907 103.224 974.528 102.872 974.325L99.4193 972.332L100.551 970.371H89.6572V967.09H102.446L104.356 963.781H92.9522V960.5H105.955V963.628L108.278 964.969C108.629 965.172 109.065 965.172 109.416 964.969C109.746 964.78 109.991 964.303 109.985 964.017L109.985 963.984V959.993H115.388V947.312H106.528V950.813C106.528 953.647 104.222 955.953 101.388 955.953H94.3876C91.5531 955.953 89.247 953.647 89.247 950.813V947.312H80.3877V1003.31H115.388V990.632H109.985ZM89.6573 973.672H96.2335V976.953H89.6573V973.672ZM89.6436 983.543H86.3623V980.262H89.6436V983.543ZM89.6436 963.781H86.3623V960.5H89.6436V963.781ZM102.823 998.254H92.9522V994.973H102.823V998.254Z"
                fill="#1BB738"
              />
            </g>
            <g filter="url(#filter3_i_100_228)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M715.541 861.501C718.21 861.708 720.907 861.812 723.629 861.812C780.79 861.812 827.129 815.474 827.129 758.312C827.129 701.151 780.79 654.812 723.629 654.812C703.09 654.812 683.948 660.795 667.851 671.113C653.825 680.103 638.39 687.812 621.731 687.812H273.129C225.08 687.812 186.129 726.764 186.129 774.812C186.129 822.861 225.08 861.812 273.129 861.812H708.129C710.626 861.812 713.098 861.707 715.541 861.501Z"
                fill="white"
              />
            </g>
            <path
              d="M715.499 861.003L715.539 861L715.58 861.003C718.236 861.208 720.92 861.312 723.629 861.312C780.514 861.312 826.629 815.198 826.629 758.312C826.629 701.427 780.514 655.312 723.629 655.312C703.188 655.312 684.139 661.266 668.121 671.534C654.077 680.536 638.54 688.312 621.731 688.312H273.129C225.356 688.312 186.629 727.04 186.629 774.812C186.629 822.585 225.356 861.312 273.129 861.312H708.129C710.612 861.312 713.07 861.208 715.499 861.003Z"
              stroke="url(#paint4_radial_100_228)"
            />
            <circle
              cx="82.5"
              cy="82.5"
              r="82.5"
              transform="matrix(-1 0 0 1 806.129 675.812)"
              fill="url(#paint5_linear_100_228)"
            />
            <circle
              opacity="0.9"
              cx="59.1949"
              cy="59.1949"
              r="59.1949"
              transform="matrix(-1 0 0 1 782.823 699.117)"
              fill="white"
            />
            <g clip-path="url(#clip3_100_228)">
              <path
                d="M742.495 786.312V784.672C742.495 784.354 742.588 784.042 742.761 783.776L745.776 779.153V766.516C745.776 765.611 745.04 764.875 744.135 764.875C743.23 764.875 742.494 765.611 742.494 766.516V771.547C742.494 772.453 741.76 773.188 740.854 773.188C739.948 773.188 739.213 772.453 739.213 771.547C739.213 770.773 739.213 765.569 739.213 764.875C739.213 763.97 738.477 763.234 737.573 763.234C736.668 763.234 735.932 763.97 735.932 764.875V771.547C735.932 772.453 735.197 773.188 734.291 773.188C733.385 773.188 732.651 772.453 732.651 771.547C732.651 770.733 732.651 764.045 732.651 763.234C732.651 762.33 731.915 761.594 731.01 761.594C730.105 761.594 729.369 762.33 729.369 763.234V771.547C729.369 772.453 728.635 773.188 727.729 773.188C726.823 773.188 726.088 772.453 726.088 771.547C726.088 770.73 726.088 754.167 726.088 753.391C726.088 752.486 725.352 751.75 724.448 751.75C723.543 751.75 722.807 752.486 722.807 753.391V772.312C722.807 773.044 722.323 773.687 721.62 773.889C720.917 774.091 720.165 773.804 719.776 773.184L716.352 767.72C715.876 766.959 714.86 766.714 714.089 767.174C713.285 767.653 713.034 768.699 713.534 769.491L722.554 783.797C722.719 784.059 722.807 784.362 722.807 784.672V786.312H742.495Z"
                fill="#DDCA27"
              />
              <path
                d="M711.323 746.828H714.604V750.109H711.323V746.828Z"
                fill="#DDCA27"
              />
              <path
                d="M712.409 764.355C714.719 762.978 717.704 763.697 719.133 765.977L719.526 766.605V753.391C719.526 751.936 720.161 750.627 721.167 749.726V745.188C721.167 744.281 721.902 743.547 722.808 743.547H729.37C730.276 743.547 731.011 744.281 731.011 745.188V751.75C731.011 752.655 730.278 753.391 729.37 753.391V758.595C731.515 757.834 733.913 758.645 735.157 760.589C735.872 760.185 736.695 759.953 737.573 759.953H737.573V740.266H701.479V773.078H711.916L710.758 771.242C709.274 768.888 710.019 765.78 712.409 764.355ZM709.683 753.391C708.776 753.391 708.042 752.656 708.042 751.75V745.188C708.042 744.281 708.776 743.547 709.683 743.547H716.245C717.151 743.547 717.886 744.281 717.886 745.188V751.75C717.886 752.656 717.151 753.391 716.245 753.391H709.683Z"
                fill="#DDCA27"
              />
              <path
                d="M718.123 782.922L713.985 776.359H701.479V778C701.479 780.714 703.687 782.922 706.401 782.922H718.123Z"
                fill="#DDCA27"
              />
              <path
                d="M727.729 749.726V746.828H724.448V748.469C725.708 748.469 726.858 748.945 727.729 749.726Z"
                fill="#DDCA27"
              />
              <path
                d="M737.573 736.984V735.234C737.573 732.52 735.365 730.312 732.651 730.312H706.401C703.687 730.312 701.479 732.52 701.479 735.234V736.984H737.573Z"
                fill="#DDCA27"
              />
            </g>
            <g filter="url(#filter4_i_100_228)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M715.541 1295.5C718.21 1295.71 720.907 1295.81 723.629 1295.81C780.79 1295.81 827.129 1249.47 827.129 1192.31C827.129 1135.15 780.79 1088.81 723.629 1088.81C703.09 1088.81 683.948 1094.8 667.851 1105.11C653.825 1114.1 638.39 1121.81 621.731 1121.81H273.129C225.08 1121.81 186.129 1160.76 186.129 1208.81C186.129 1256.86 225.08 1295.81 273.129 1295.81H708.129C710.626 1295.81 713.098 1295.71 715.541 1295.5Z"
                fill="white"
              />
            </g>
            <path
              d="M715.499 1295L715.539 1295L715.58 1295C718.236 1295.21 720.92 1295.31 723.629 1295.31C780.514 1295.31 826.629 1249.2 826.629 1192.31C826.629 1135.43 780.514 1089.31 723.629 1089.31C703.188 1089.31 684.139 1095.27 668.121 1105.53C654.077 1114.54 638.54 1122.31 621.731 1122.31H273.129C225.356 1122.31 186.629 1161.04 186.629 1208.81C186.629 1256.59 225.356 1295.31 273.129 1295.31H708.129C710.612 1295.31 713.07 1295.21 715.499 1295Z"
              stroke="url(#paint6_linear_100_228)"
            />
            <circle
              cx="82.5"
              cy="82.5"
              r="82.5"
              transform="matrix(-1 0 0 1 806.129 1109.81)"
              fill="url(#paint7_linear_100_228)"
            />
            <circle
              opacity="0.9"
              cx="59.1949"
              cy="59.1949"
              r="59.1949"
              transform="matrix(-1 0 0 1 782.823 1133.12)"
              fill="white"
            />
            <g clip-path="url(#clip4_100_228)">
              <path
                d="M736.753 1190.67H738.228C737.909 1187.84 736.808 1185.27 735.113 1183.15L734.069 1184.19C733.749 1184.51 733.329 1184.67 732.909 1184.67C732.49 1184.67 732.07 1184.51 731.75 1184.19C731.109 1183.55 731.109 1182.51 731.75 1181.87L732.793 1180.83C730.675 1179.13 728.102 1178.03 725.269 1177.71V1179.19C725.269 1180.09 724.535 1180.83 723.628 1180.83C722.721 1180.83 721.987 1180.09 721.987 1179.19V1177.71C719.154 1178.03 716.581 1179.13 714.463 1180.83L715.506 1181.87C716.147 1182.51 716.147 1183.55 715.506 1184.19C715.186 1184.51 714.766 1184.67 714.346 1184.67C713.927 1184.67 713.507 1184.51 713.187 1184.19L712.143 1183.15C710.448 1185.27 709.347 1187.84 709.028 1190.67H710.503C711.41 1190.67 712.144 1191.41 712.144 1192.31C712.144 1193.22 711.41 1193.95 710.503 1193.95H708.982C709.243 1196.3 710.03 1198.54 711.357 1200.52H735.899C737.227 1198.54 738.014 1196.3 738.274 1193.95H736.753C735.846 1193.95 735.112 1193.22 735.112 1192.31C735.112 1191.41 735.846 1190.67 736.753 1190.67ZM729.82 1188.44L728.056 1190.2C728.364 1190.85 728.55 1191.56 728.55 1192.31C728.55 1195.03 726.342 1197.23 723.628 1197.23C720.914 1197.23 718.706 1195.03 718.706 1192.31C718.706 1189.6 720.914 1187.39 723.628 1187.39C724.385 1187.39 725.095 1187.58 725.736 1187.88L727.501 1186.12C728.141 1185.48 729.18 1185.48 729.82 1186.12C730.461 1186.76 730.461 1187.8 729.82 1188.44Z"
                fill="#1ED38D"
              />
              <path
                d="M723.628 1190.67C722.723 1190.67 721.987 1191.41 721.987 1192.31C721.987 1193.22 722.723 1193.95 723.628 1193.95C724.533 1193.95 725.269 1193.22 725.269 1192.31C725.269 1191.41 724.533 1190.67 723.628 1190.67Z"
                fill="#1ED38D"
              />
              <path
                d="M750.386 1187.44L747.593 1186.77C746.981 1184.1 745.943 1181.59 744.498 1179.28L745.916 1176.92C746.304 1176.27 746.201 1175.44 745.669 1174.91L741.029 1170.27C740.496 1169.74 739.674 1169.64 739.025 1170.02L736.66 1171.44C734.351 1170 731.84 1168.96 729.171 1168.35L728.5 1165.55C728.317 1164.83 727.662 1164.31 726.909 1164.31H720.347C719.593 1164.31 718.938 1164.83 718.756 1165.55L718.084 1168.35C715.415 1168.96 712.904 1170 710.596 1171.44L708.231 1170.02C707.585 1169.64 706.759 1169.74 706.227 1170.27L701.587 1174.91C701.055 1175.44 700.952 1176.27 701.34 1176.92L702.758 1179.28C701.313 1181.59 700.275 1184.1 699.662 1186.77L696.87 1187.44C696.141 1187.62 695.628 1188.28 695.628 1189.03V1195.59C695.628 1196.35 696.141 1197 696.87 1197.18L699.663 1197.86C700.275 1200.53 701.313 1203.04 702.758 1205.34L701.34 1207.71C700.952 1208.36 701.055 1209.18 701.587 1209.71L706.227 1214.35C706.757 1214.89 707.585 1214.99 708.231 1214.6L710.596 1213.18C712.904 1214.63 715.415 1215.67 718.084 1216.28L718.756 1219.07C718.938 1219.8 719.593 1220.31 720.347 1220.31H726.909C727.662 1220.31 728.317 1219.8 728.5 1219.07L729.171 1216.28C731.841 1215.67 734.351 1214.63 736.66 1213.18L739.025 1214.6C739.672 1214.99 740.496 1214.89 741.029 1214.35L745.669 1209.71C746.201 1209.18 746.304 1208.36 745.916 1207.71L744.498 1205.34C745.943 1203.04 746.981 1200.53 747.593 1197.86L750.386 1197.18C751.115 1197 751.628 1196.35 751.628 1195.59V1189.03C751.628 1188.28 751.115 1187.62 750.386 1187.44ZM726.909 1210.36H720.347C719.44 1210.36 718.706 1209.63 718.706 1208.72C718.706 1207.81 719.44 1207.08 720.347 1207.08H726.909C727.816 1207.08 728.55 1207.81 728.55 1208.72C728.55 1209.63 727.816 1210.36 726.909 1210.36ZM738.056 1203.14C737.746 1203.56 737.261 1203.8 736.745 1203.8H710.511C709.995 1203.8 709.51 1203.56 709.2 1203.14C706.832 1199.99 705.581 1196.25 705.581 1192.31C705.581 1182.36 713.677 1174.27 723.628 1174.27C733.579 1174.27 741.675 1182.36 741.675 1192.31C741.675 1196.25 740.423 1200 738.056 1203.14Z"
                fill="#1ED38D"
              />
            </g>
            <g filter="url(#filter5_i_100_228)">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M717.541 424.501C720.21 424.708 722.907 424.812 725.629 424.812C782.79 424.812 829.129 378.474 829.129 321.312C829.129 264.151 782.79 217.812 725.629 217.812C705.09 217.812 685.948 223.795 669.851 234.113C655.825 243.103 640.39 250.812 623.731 250.812H275.129C227.08 250.812 188.129 289.764 188.129 337.812C188.129 385.861 227.08 424.812 275.129 424.812H710.129C712.626 424.812 715.098 424.707 717.541 424.501Z"
                fill="white"
              />
            </g>
            <path
              d="M717.499 424.003L717.539 424L717.58 424.003C720.236 424.208 722.92 424.312 725.629 424.312C782.514 424.312 828.629 378.198 828.629 321.312C828.629 264.427 782.514 218.312 725.629 218.312C705.188 218.312 686.139 224.266 670.121 234.534C656.077 243.536 640.54 251.312 623.731 251.312H275.129C227.356 251.312 188.629 290.04 188.629 337.812C188.629 385.585 227.356 424.312 275.129 424.312H710.129C712.612 424.312 715.07 424.208 717.499 424.003Z"
              stroke="#00E1DB"
            />
            <circle
              cx="724.629"
              cy="321.312"
              r="82.5"
              fill="url(#paint8_linear_100_228)"
            />
            <circle
              opacity="0.9"
              cx="724.629"
              cy="321.312"
              r="59.1949"
              fill="white"
            />
            <g clip-path="url(#clip5_100_228)">
              <path
                d="M696.629 338.557V340.197C696.629 342.911 698.837 345.119 701.551 345.119H722.441V338.557H696.629Z"
                fill="#E04713"
              />
              <path
                d="M713.035 318.869C711.527 318.869 710.301 320.096 710.301 321.604C710.301 323.111 711.527 324.338 713.035 324.338C714.543 324.338 715.77 323.111 715.77 321.604C715.77 320.096 714.543 318.869 713.035 318.869Z"
                fill="#E04713"
              />
              <path
                d="M707.249 323.244H706.473V327.619H710.848V327.206C709.11 326.525 707.764 325.058 707.249 323.244Z"
                fill="#E04713"
              />
              <path
                d="M701.551 308.479C698.837 308.479 696.629 310.686 696.629 313.4V335.275H722.441V308.479H701.551ZM714.129 327.518V330.9H703.191V319.963H707.249C707.965 317.441 710.287 315.588 713.035 315.588C716.352 315.588 719.051 318.287 719.051 321.604C719.051 324.547 716.925 327.002 714.129 327.518Z"
                fill="#E04713"
              />
              <path
                d="M736.545 326.963H735.566V330.244H738.848V329.564C737.798 329.008 736.973 328.083 736.545 326.963Z"
                fill="#E04713"
              />
              <path
                d="M734.801 303.447V309.463C734.801 309.764 735.046 310.01 735.348 310.01H743.004C743.305 310.01 743.551 309.764 743.551 309.463V303.447H734.801Z"
                fill="#E04713"
              />
              <path
                d="M741.145 323.572C740.24 323.572 739.504 324.308 739.504 325.213C739.504 326.118 740.24 326.854 741.145 326.854C742.049 326.854 742.785 326.118 742.785 325.213C742.785 324.308 742.049 323.572 741.145 323.572Z"
                fill="#E04713"
              />
              <path
                d="M748.801 303.447H746.832V309.463C746.832 311.574 745.115 313.291 743.004 313.291H735.348C733.237 313.291 731.52 311.574 731.52 309.463V303.447H729.551C727.44 303.447 725.723 305.165 725.723 307.275V346.65C725.723 348.761 727.44 350.479 729.551 350.479H748.801C750.912 350.479 752.629 348.761 752.629 346.65V307.275C752.629 305.165 750.912 303.447 748.801 303.447ZM742.129 330.036V333.525H732.285V323.682H736.468C737.113 321.715 738.965 320.291 741.145 320.291C743.858 320.291 746.066 322.499 746.066 325.213C746.066 327.59 744.373 329.578 742.129 330.036Z"
                fill="#E04713"
              />
            </g>
            <path
              d="M285.129 11.8125H558.129C618.328 11.8125 667.129 60.6135 667.129 120.812C667.129 181.012 618.328 229.812 558.129 229.812H272.129C211.93 229.812 163.129 278.613 163.129 338.812C163.129 399.012 211.93 447.812 272.129 447.812H558.129C618.328 447.812 667.129 496.613 667.129 556.812C667.129 617.012 618.328 665.812 558.129 665.812H272.129C211.93 665.812 163.129 714.613 163.129 774.812C163.129 835.012 211.93 883.812 272.129 883.812H558.129C618.328 883.812 667.129 932.613 667.129 992.812C667.129 1053.01 618.328 1101.81 558.129 1101.81H272.129C211.93 1101.81 163.129 1150.61 163.129 1210.81C163.129 1271.01 211.93 1319.81 272.129 1319.81H558.129"
              stroke="url(#paint9_linear_100_228)"
              stroke-width="20"
              stroke-linecap="round"
              id="filling_path"
            />
            <defs>
              <filter
                id="filter0_i_100_228"
                x="0.128906"
                y="0.8125"
                width="641"
                height="218"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="11" />
                <feGaussianBlur stdDeviation="10" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_100_228"
                />
              </filter>
              <filter
                id="filter1_i_100_228"
                x="0.128906"
                y="437.812"
                width="641"
                height="218"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="11" />
                <feGaussianBlur stdDeviation="10" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_100_228"
                />
              </filter>
              <filter
                id="filter2_i_100_228"
                x="0.128906"
                y="871.812"
                width="641"
                height="218"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="11" />
                <feGaussianBlur stdDeviation="10" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_100_228"
                />
              </filter>
              <filter
                id="filter3_i_100_228"
                x="186.129"
                y="654.812"
                width="641"
                height="218"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="11" />
                <feGaussianBlur stdDeviation="10" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_100_228"
                />
              </filter>
              <filter
                id="filter4_i_100_228"
                x="186.129"
                y="1088.81"
                width="641"
                height="218"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="11" />
                <feGaussianBlur stdDeviation="10" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_100_228"
                />
              </filter>
              <filter
                id="filter5_i_100_228"
                x="188.129"
                y="217.812"
                width="641"
                height="218"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="BackgroundImageFix"
                  result="shape"
                />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feOffset dy="11" />
                <feGaussianBlur stdDeviation="10" />
                <feComposite
                  in2="hardAlpha"
                  operator="arithmetic"
                  k2="-1"
                  k3="1"
                />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                  mode="normal"
                  in2="shape"
                  result="effect1_innerShadow_100_228"
                />
              </filter>
              <linearGradient
                id="paint0_linear_100_228"
                x1="103.629"
                y1="21.8125"
                x2="103.629"
                y2="186.812"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#1B91DA" />
                <stop offset="1" stop-color="#0E4D74" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_100_228"
                x1="103.629"
                y1="458.812"
                x2="103.629"
                y2="623.812"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#0065F4" />
                <stop offset="1" stop-color="#0F4798" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_100_228"
                x1="665.536"
                y1="871.812"
                x2="9.05439"
                y2="871.812"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#21D342" />
                <stop offset="1" stop-color="#258136" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_100_228"
                x1="103.629"
                y1="892.812"
                x2="103.629"
                y2="1057.81"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#21D342" />
                <stop offset="1" stop-color="#258136" />
              </linearGradient>
              <radialGradient
                id="paint4_radial_100_228"
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(506.629 758.312) rotate(90) scale(103.5 320.5)"
              >
                <stop stop-color="#FFE81E" />
                <stop offset="1" stop-color="#C4B214" />
              </radialGradient>
              <linearGradient
                id="paint5_linear_100_228"
                x1="82.5"
                y1="0"
                x2="82.5"
                y2="165"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FFE81E" />
                <stop offset="1" stop-color="#C4B214" />
              </linearGradient>
              <linearGradient
                id="paint6_linear_100_228"
                x1="506.629"
                y1="1088.81"
                x2="506.629"
                y2="1295.81"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#1EFFA8" />
                <stop offset="1" stop-color="#14C480" />
              </linearGradient>
              <linearGradient
                id="paint7_linear_100_228"
                x1="82.5"
                y1="0"
                x2="82.5"
                y2="165"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#1EFFA8" />
                <stop offset="1" stop-color="#14C480" />
              </linearGradient>
              <linearGradient
                id="paint8_linear_100_228"
                x1="724.629"
                y1="238.812"
                x2="724.629"
                y2="403.812"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FC490B" />
                <stop offset="1" stop-color="#C7471A" />
              </linearGradient>
              <linearGradient
                id="paint9_linear_100_228"
                x1="415.129"
                y1="883.812"
                x2="415.129"
                y2="1755.81"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#09C2C1" />
                <stop offset="1" stop-color="#1D85D8" />
              </linearGradient>
              <clipPath id="clip0_100_228">
                <rect
                  width="56"
                  height="56"
                  fill="white"
                  transform="translate(75.6299 76.3125)"
                />
              </clipPath>
              <clipPath id="clip1_100_228">
                <rect
                  width="56"
                  height="56"
                  fill="white"
                  transform="translate(75.6299 513.312)"
                />
              </clipPath>
              <clipPath id="clip2_100_228">
                <rect
                  width="56"
                  height="56"
                  fill="white"
                  transform="translate(75.6299 947.312)"
                />
              </clipPath>
              <clipPath id="clip3_100_228">
                <rect
                  width="56"
                  height="56"
                  fill="white"
                  transform="translate(695.628 730.312)"
                />
              </clipPath>
              <clipPath id="clip4_100_228">
                <rect
                  width="56"
                  height="56"
                  fill="white"
                  transform="translate(695.628 1164.31)"
                />
              </clipPath>
              <clipPath id="clip5_100_228">
                <rect
                  width="56"
                  height="56"
                  fill="white"
                  transform="translate(696.629 298.963)"
                />
              </clipPath>
            </defs>
          </svg>

          <div className="content_detail">
            <div className="col_detail figma-">
              <div data-aos="zoom-in-up" className="icons" data-aos-delay="600">
                <img src="./assets/images/portfolio/mobflow1.svg" alt="" />
              </div>
              <h4 data-aos="zoom-in-up" data-aos-delay="600">
                {/* Custom Mobile App Development */}
                <a href="/mobile-app-development">Custom Mobile App Development </a>
              </h4>
              <hr
                data-aos="zoom-in-up"
                data-aos-delay="600"
                style={{ borderColor: "#004875" }}
              />
              <p data-aos="zoom-in-up" data-aos-delay="600"> 
              We craft tailor-made mobile applications designed to meet your business needs and offer unique user experiences. Whether you need an app for iOS, Android, or both, we’ve got you covered with cross-platform solutions.
              </p>
            </div>
            <div className="col_detail prototipe-">
              <div data-aos="zoom-in-up" className="icons" data-aos-delay="600">
              <img src="./assets/images/portfolio/mobflow2.svg" alt="" />
              </div>
              <h4 data-aos="zoom-in-up" data-aos-delay="600">
                Native & Cross-Platform Apps
              </h4>
              <hr
                data-aos="zoom-in-up"
                data-aos-delay="600"
                style={{ borderColor: "#c7471a" }}
              />
              <p data-aos="zoom-in-up" data-aos-delay="600">
              We build both native apps (iOS/Android) and cross-platform apps (using technologies like React Native, Flutter) to ensure your app delivers high performance across all devices while maintaining consistency.
              </p>
            </div>
            <div className="col_detail ps-">
              <div data-aos="zoom-in-up" className="icons" data-aos-delay="600">
              <img src="./assets/images/portfolio/mobflow3.svg" alt="" />
              </div>
              <h4 data-aos="zoom-in-up" data-aos-delay="600">
                <a href="/app-uiux-design"> App UI/UX Design</a>
              </h4>
              <hr
                data-aos="zoom-in-up"
                data-aos-delay="600"
                style={{ borderColor: "#0f4798" }}
              />
              <p data-aos="zoom-in-up" data-aos-delay="600">
              We design mobile apps that are not only functional but also visually stunning. Our intuitive and engaging interfaces enhance the user experience, ensuring your app is easy to navigate and keeps users coming back.
              </p>
            </div>
            <div className="col_detail adobe-">
              <div data-aos="zoom-in-up" className="icons" data-aos-delay="600">
              <img src="./assets/images/portfolio/mobflow4.svg" alt="" />
                            </div>
              <h4 data-aos="zoom-in-up" data-aos-delay="600">
                <a href="/enterprise-mobile-solutions">Enterprise Mobile Solutions</a>
              </h4>
              <hr
                data-aos="zoom-in-up"
                data-aos-delay="600"
                style={{ borderColor: "#c3b214" }}
              />
              <p data-aos="zoom-in-up" data-aos-delay="600">
              We develop scalable, secure enterprise apps that integrate seamlessly with your internal systems, enabling you to streamline operations and boost productivity across your teams.
              </p>
            </div>
            <div className="col_detail ps-">
              <div data-aos="zoom-in-up" className="icons" data-aos-delay="600">
              <img src="./assets/images/portfolio/mobflow5.svg" alt="" />
              </div>
              <h4 data-aos="zoom-in-up" data-aos-delay="600">
                <a href="/app-maintenance-updates">App Maintenance & Updates</a>
                
              </h4>
              <hr
                data-aos="zoom-in-up"
                data-aos-delay="600"
                style={{ borderColor: "#21D342" }}
              />
              <p data-aos="zoom-in-up" data-aos-delay="600">
              Launching the app is just the beginning. We offer ongoing maintenance, feature updates, and performance optimization to ensure your app evolves as your business grows.
              </p>
            </div>
            <div className="col_detail adobe-">
              <div data-aos="zoom-in-up" className="icons" data-aos-delay="600">
              <img src="./assets/images/portfolio/mobflow6.svg" alt="" />
              </div>
              <h4 data-aos="zoom-in-up" data-aos-delay="600">
                <a href="/app-store-optimization">App Store Optimization (ASO)</a>
                
              </h4> 
              <hr
                data-aos="zoom-in-up"
                data-aos-delay="600"
                style={{ borderColor: "#1EFFA8" }}
              />
              <p data-aos="zoom-in-up" data-aos-delay="600">
              We implement strategies to enhance your app’s visibility and ranking on app stores (Google Play and App Store), <br/> ensuring more  downloads and better user engagement.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileDevFlow;
